import { ViewSizes } from '@shared-ui/viewport-context';
export const viewportMap = {
  [ViewSizes.SMALL]: ViewSizes.SMALL,
  [ViewSizes.MEDIUM]: ViewSizes.MEDIUM,
  [ViewSizes.LARGE]: ViewSizes.LARGE,
  [ViewSizes.EXTRA_LARGE]: ViewSizes.EXTRA_LARGE
};